import { scaleOrdinal } from 'd3-scale';
import { color } from 'd3-color';

export function colorScale(nbhColor) {
  if (nbhColor) {
    let assignColor = scaleOrdinal()
      .domain([
        'George Gascón',
        'Nathan Hochman',
        'John Mckinney',
        'Jonathan Hatami',
        'Maria Ramirez',
        'Debra Archuleta',
        'Eric Siddall',
        'Jeff Chemerinsky',
        'Dan Kapelovitz',
        'Craig Mitchell',
        'David Milton',
        'Lloyd Masson',
      ])
      .range([
        '#e3974e',
        '#af89be',
        '#5bc7a3',
        '#5bc7a3',
        '#5bc7a3',
        '#5bc7a3',
        '#5bc7a3',
        '#5bc7a3',
        '#5bc7a3',
        '#5bc7a3',
        '#5bc7a3',
        '#5bc7a3',
      ]);

    let finalColor = color(assignColor(nbhColor)).formatHex();

    return finalColor;
  } else {
    return '#c6c6c6';
  }
}
